import * as actions from '../actionTypes'

// pageDocs is { first: <doc>, last: <doc> } for that page, and used by prev/next
const initialState = { 
    value: {
        page: 0,
        order: 'desc',
        orderBy: 'created',
        allocated: ''
    }
}

export default function accountGridPagination(state = initialState, action) {

    switch(action.type) {

        case actions.SET_ACCOUNT_GRID_PAGINATION: {

            //console.log('[r] Setting work order grid pagination value', action.payload.value)
            return {
                ...state,
                value: action.payload.value
            }
        }

        default:
            return state
    }
}